import { ChartOfAccount } from "./chart-of-account";
import { SystemField } from "./system-field";

export class AccountingClass extends SystemField { 
     
     name?:string;
     class_type?:string;
     is_active?:number;
     code?:string;
     ordering?:number;

     chart_of_accounts?:ChartOfAccount[];
}
